import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    apiUser: string = "";

    constructor(
        private http: HttpClient
    ) {
    }

    getAllPermissionsInContract() {
        this.apiUser = environment.apiUser;
        return this.http.get(`${this.apiUser}/permissions`)
    }
}
